import _ from 'underscore'
import React from 'react'
import styled from 'styled-components'

import Tabs, { Tab } from 'components/Tabs'

import FaceplateMessages from 'pages/DeviceAggregator/FaceplateMessages'
import CurrentDeviceState from 'pages/DeviceAggregator/CurrentDeviceState'
import DeviceDetails from 'pages/DeviceAggregator/DeviceDetails'
import DeviceMetrics from 'pages/MaintenanceTrends/DeviceMetrics'
import Customer from 'pages/DeviceAggregator/Customer'
import RthChart from 'pages/DeviceAggregator/RthChart'

import Environment from 'helpers/environment'
import { DeviceTypes } from 'helpers/constants'

import { useSessionContext } from 'hooks/SessionContext'

type Props = {
  deviceId: string
  timeZone: string
  deviceType: string
}

const TABS = [
  { header: 'Customer Details', detailsComponent: Customer },
  { header: 'Device Details', detailsComponent: DeviceDetails },
  { header: 'Faceplate Messages', detailsComponent: FaceplateMessages },
  { header: 'Device State - Current', detailsComponent: CurrentDeviceState },
  { header: 'Device Metrics', detailsComponent: DeviceMetrics },
  { header: 'RTH Chart', detailsComponent: RthChart }
]

const HEHM_TABS = [
  { header: 'Customer Details', detailsComponent: Customer },
  { header: 'Device Details', detailsComponent: DeviceDetails },
  { header: 'Messages', detailsComponent: FaceplateMessages }
]

const DeviceAggregatorTabs = ({ deviceId, timeZone, deviceType }: Props) => {
  const updatedTabs = deviceType === DeviceTypes.HEHM ? HEHM_TABS : TABS
  const { session: { isDeveloper } } = useSessionContext()

  if (Environment.isProduction() || !isDeveloper) {
    const index = updatedTabs.findIndex(tab => tab.header === 'Device Metrics')

    if (index !== -1) {
      updatedTabs.splice(index, 1)
    }
  }

  return (
    <Tabs
      tabItems={
        _.map(updatedTabs, r => {
          const item: Tab = {
            key: r.header,
            header: <S.Header>{r.header}</S.Header>,
            details: <r.detailsComponent {...{ deviceId, timeZone, deviceType }} />
          }

          return item
        })
      }
    />
  )
}

export default DeviceAggregatorTabs

const S = {
  Header: styled.div`
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
  `
}
